import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { getCheckout } from "../../Core/CheckOut/action";
import styles from "../../Assets/Styles/Components/Book/checkout.module.css";

class Checkout extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    props.getCheckout(props.slug, props.data.step);
  }

  componentDidUpdate(preProps) {
    if (this.props.data !== preProps.data) {
      this.props.getCheckout(this.props.slug, this.props.data.step);
    }
    if (window.location.pathname !== this.props.history.location.pathname) {
      this.props.getCheckout(this.props.slug, this.props.data.step);
    }
    if (
      this.props.history.location.pathname ===
      preProps.history.location.pathname
    ) {
      document
        .querySelector(`#checkOut`)
        .scrollIntoView({ behavior: "smooth" });
    }
  }

  goBack = (path, here) => () => {
    const hh = path.findIndex(i => {
      return i.step === here;
    });
    this.props.history.push(
      `${path[hh - 1].step}?slug=${this.props.project.slug}`
    );
  };

  render() {
    const { checkout, data } = this.props;
    let currentStep = 0;
    checkout &&
      checkout.checkout &&
      checkout.checkout.steps &&
      (currentStep = checkout.checkout.steps.findIndex(i => {
        return this.props.data.step === i.step;
      }));
    const thisView = this.props.history.location.pathname.slice(1).split("/");
    let currentIndex = 0;
    checkout &&
      checkout.checkout &&
      checkout.checkout.steps &&
      (currentIndex = checkout.checkout.steps.findIndex(i => {
        return thisView[1] === i.step;
      }));
    return (
      <div className={styles.checkoutPadd} id="checkOut">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className={styles.checkoutBox}>
                {checkout &&
                  checkout.checkout &&
                  checkout.checkout.steps &&
                  !checkout.checkout.back_lock &&
                  <div
                    className={`${styles.back} ${thisView[1] ===
                    checkout.checkout.steps[0].step
                      ? styles.backHidden
                      : ""}`}
                    onClick={this.goBack(checkout.checkout.steps, thisView[1])}
                  >
                    <i className="fas fa-caret-right" />
                  </div>}
                <ul>
                  {checkout &&
                    checkout.checkout &&
                    checkout.checkout.steps &&
                    checkout.checkout.steps
                      .slice(0, -2) // Hide the last 2 steps
                      .map((i, index) => {
                      let style = "";
                      if (index < currentIndex) {
                        style = `fa-check-circle ${styles.passed}`;
                      }
                      if (index === currentIndex) {
                        style = `fa-arrow-circle-down`;
                      }
                      if (index > currentIndex) {
                        style = `fa-circle`;
                      }
                      return (
                        <li
                          key={i.step}
                          className={`${styles.stepBox} ${styles.bullet} ${currentIndex ===
                          index
                            ? styles.active
                            : ""} ${index < currentIndex ? styles.passed : ""}`}
                          onClick={() => {
                            !checkout.checkout.back_lock &&
                              index <= currentStep &&
                              this.props.history.push(
                                `${i.step}?slug=${this.props.project.slug}`
                              );
                          }}
                        >
                          <i className={`fas ${style}`} />
                          <span
                            className={`${styles.title} ${currentIndex === index
                              ? styles.currentTitle
                              : ""}`}
                          >
                            {i.name}
                          </span>
                        </li>
                      );
                    })}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    state,
    checkout: state.checkout,
    project: state.project
  };
};
export default connect(mapStateToProps, { getCheckout })(withRouter(Checkout));
